import ButtonIcon from "@components/Buttons/ButtonIcon/ButtonIcon";
import { ReactComponent as Bell } from "@assets/icon/bell.svg";
import { ReactComponent as Alarm } from "@assets/icon/alarm.svg";
import { ReactComponent as SearchMobile } from "@assets/icon/searchMobile.svg";
import { ReactComponent as MessagesMobile } from "@assets/icon/messagesMobile.svg";

import { IconsContainer } from "../../styled";
import Icon from "@components/Icon/Icon";

const HeaderIcons = ({ isMobile }: { isMobile: boolean }) => {
    return (
        <IconsContainer>
            {isMobile && (
                <ButtonIcon
                    type="text"
                    icon={<Icon icon={SearchMobile} color="var(--header-icons)" size="sm" />}
                    onClick={() => {}}
                />
            )}
            <ButtonIcon
                type="text"
                icon={<Icon icon={Bell} color="var(--header-icons)" size="sm" />}
                onClick={() => {}}
            />
            <ButtonIcon
                type="text"
                icon={<Icon icon={MessagesMobile} color="var(--header-icons)" size="sm" />}
                onClick={() => {}}
            />
            <ButtonIcon
                type="text"
                icon={<Icon icon={Alarm} color="var(--header-icons)" size="sm" />}
                onClick={() => {}}
            />
        </IconsContainer>
    );
};
export default HeaderIcons;
